import { TableActions } from '@core/components/Table';
import AddIcon from '@material-ui/icons/Add';
import { permissaoUtils } from '@core/util/permissaoUtil';
import DeleteIcon from '@material-ui/icons/Delete';
import React, { useContext } from 'react';
import { TransferenciaContext } from '../TransferenciaContext';

const TransferenciaFab = ({ cadastrar, onExcluir }) => {
  const [selecao] = useContext(TransferenciaContext).selecao;

  const handleOpenCadastrarModal = () => {
    cadastrar();
  };

  const actions = [
    { 
      icon: <DeleteIcon />,
      name: 'excluir',
      tooltip: 'Excluir',
      show: permissaoUtils.transferencia().excluir,
      onClick: () => {
        onExcluir({ ids: selecao });
      },
    },
    {
      icon: <AddIcon />,
      name: 'cadastrar',
      tooltip: 'Cadastrar',
      show: permissaoUtils.transferencia().cadastrar,
      onClick: handleOpenCadastrarModal,
    },
  ];

  return <TableActions className={'stepPlusButton'} actions={actions} />;
};

export default TransferenciaFab;
